import Vue from "vue";
import axios from "axios";
import { tokenConfig } from "@/helpers/auth";

export default {
  state() {
    return {
      groups: [],
      group: {},
      groupItems: [],
      groupItem: {},

      //Expenses
      expensesGroups: [],
      expensesGroup: {},
      expenses: [],
      expense: {},

      exhaustedProducts: [],

      groupTimelineDateFrom: new Date().toISOString().substr(0, 10),
      groupTimelineDateTo: new Date().toISOString().substr(0, 10),

      groupTimelineTimeFrom: "00:00",
      groupTimelineTimeTo: "23:59",

      analysesValues: {},

      breakdownItemsByName: [],
      breakdownItemsByPrice: [],
      breakdownItemsByOrders: [],
      breakdownItemsBySales: [],

      groupNotFound: null,
      expensesGroupNotFound: null,
      newGroupDialog: false,
      newExpensesGroupDialog: false,
      addGroupProductDialog: false,
      addExpenseDialog: false,
      editGroupTimelineDialog: false,
      editGroupItemCostDialog: false,
      groupAnalysesDialog: false,
      breakdownByNameDialog: false,
      breakdownByPriceDialog: false,
      breakdownByOrdersDialog: false,
      breakdownBySalesDialog: false,
      analysesReportContactListDialog: false,
    };
  },

  getters: {
    allExemptedProducts(state, getters, rootState) {
      if (state.groupItems.length < 1) return rootState.products.products;

      var allProducts = JSON.parse(JSON.stringify(rootState.products.products));
      var productsToTrim = JSON.parse(
        JSON.stringify(rootState.products.products)
      );

      var groupItems = JSON.parse(JSON.stringify(state.groupItems));

      for (var product_out of allProducts) {
        var duplicate = groupItems.filter(
          (groupProduct) => groupProduct.product === product_out.id
        );
        productsToTrim.splice;
        if (duplicate.length) {
          productsToTrim
            .filter((product_in) => product_in.id === duplicate[0].product)
            .map((product_in) =>
              productsToTrim.splice(productsToTrim.indexOf(product_in), 1)
            );
        }
      }

      return productsToTrim;
    },
  },

  mutations: {
    setGroupNotFound(state, status = null) {
      state.groupNotFound = status;
    },

    setExpensesGroupNotFound(state, status = null) {
      state.expensesGroupNotFound = status;
    },

    refreshGroups(state, payload) {
      state.groups = [];
      state.groups = payload;
    },

    refreshExpensesGroups(state, payload) {
      state.expensesGroups = [];
      state.expensesGroups = payload;
    },

    refreshExhaustedProducts(state, payload) {
      state.exhaustedProducts = [];
      state.exhaustedProducts = payload;
    },

    refreshGroup(state, payload) {
      state.group = {};
      state.group = payload;
    },

    refreshExpensesGroup(state, payload) {
      state.expensesGroup = {};
      state.expensesGroup = payload;
    },

    refreshGroupItems(state, payload) {
      state.groupItems = [];
      state.groupItems = payload;
    },

    refreshExpenses(state, payload) {
      state.expenses = [];
      state.expenses = payload;
    },

    setAnalysesValues(state, payload) {
      (state.analysesValues = {}), (state.analysesValues = payload);
    },

    setBreakdownItemsByName(state, payload) {
      state.breakdownItemsByName = [];
      state.breakdownItemsByName = payload;
    },

    setBreakdownItemsByPrice(state, payload) {
      state.breakdownItemsByPrice = [];
      state.breakdownItemsByPrice = payload;
    },

    setBreakdownItemsByOrders(state, payload) {
      state.breakdownItemsByOrders = [];
      state.breakdownItemsByOrders = payload;
    },

    setBreakdownItemsBySales(state, payload) {
      state.breakdownItemsBySales = [];
      state.breakdownItemsBySales = payload;
    },

    setAnalysesReportContactListDialog(state, status = null) {
      state.analysesReportContactListDialog = status;
    },

    refreshGroupItem(state, payload) {
      state.groupItem = {};
      state.groupItem = Object.assign({}, state.groupItem, payload);
    },

    refreshExpense(state, payload) {
      state.expense = {};
      state.expense = Object.assign({}, state.expense, payload);
    },

    setNewGroupDialog(state, status = null) {
      state.newGroupDialog = status;
    },

    setNewExpensesGroupDialog(state, status = null) {
      state.newExpensesGroupDialog = status;
    },

    setAddGroupProductDialog(state, status = null) {
      state.addGroupProductDialog = status;
    },

    setAddExpenseDialog(state, status = null) {
      state.addExpenseDialog = status;
    },

    setEditGroupTimelineDialog(state, status = null) {
      state.editGroupTimelineDialog = status;
    },

    setGroupTimelineDateFrom(state, value) {
      state.groupTimelineDateFrom = value;
    },

    setGroupTimelineTimeFrom(state, value) {
      state.groupTimelineTimeFrom = value;
    },

    setGroupTimelineDateTo(state, value) {
      state.groupTimelineDateTo = value;
    },

    setGroupTimelineTimeTo(state, value) {
      state.groupTimelineTimeTo = value;
    },

    setGroupAnalysesDialog(state, status = null) {
      state.groupAnalysesDialog = status;
    },

    setBreakdownByNameDialog(state, status = null) {
      state.breakdownByNameDialog = status;
    },

    setBreakdownByPriceDialog(state, status = null) {
      state.breakdownByPriceDialog = status;
    },

    setBreakdownByOrdersDialog(state, status = null) {
      state.breakdownByOrdersDialog = status;
    },

    setBreakdownBySalesDialog(state, status = null) {
      state.breakdownBySalesDialog = status;
    },

    setEditGroupItemCostDialog(state, status = null) {
      state.editGroupItemCostDialog = status;
    },
  },

  actions: {
    getExhaustedProducts({ dispatch, commit, rootState }, branchId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `/api/v1/analyses/product/${branchId}/exhausted_products/`,
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setBranchNotFound", false);
            commit(
              "refreshExhaustedProducts",
              response.data["branch_products"]
            );
            commit("setBranchVendor", response.data["branch_vendor"]);
            resolve(response);
          })
          .catch((error) => {
            if (error.response && error.response.status === 404)
              commit("setBranchNotFound", true);
            else dispatch("handleError", error);
            reject(error);
          });
      });
    },

    getGroups({ dispatch, commit, rootState }, branchId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `/api/v1/analyses/group/${branchId}/branch_groups/`,
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setBranchNotFound", false);
            commit("refreshGroups", response.data);
            resolve(response);
          })
          .catch((error) => {
            if (error.response && error.response.status === 404)
              commit("setBranchNotFound", true);
            else dispatch("handleError", error);
            reject(error);
          });
      });
    },

    getExpensesGroups({ dispatch, commit, rootState }, branchId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `/api/v1/expenses/expense/${branchId}/branch_expenses_groups/`,
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setBranchNotFound", false);
            commit("refreshExpensesGroups", response.data);
            resolve(response);
          })
          .catch((error) => {
            if (error.response && error.response.status === 404)
              commit("setBranchNotFound", true);
            else dispatch("handleError", error);
            reject(error);
          });
      });
    },

    getGroup({ dispatch, commit, rootState }, groupId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `/api/v1/analyses/group/${groupId}/branch_group/`,
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setGroupNotFound", false);
            commit("refreshGroup", response.data["group"]);
            commit("refreshGroupItems", response.data["group_items"]);
            resolve(response);
          })
          .catch((error) => {
            if (error.response && error.response.status === 404)
              commit("setGroupNotFound", true);
            else dispatch("handleError", error);
            reject(error);
          });
      });
    },

    getExpensesGroup({ dispatch, commit, rootState }, groupId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `/api/v1/expenses/expense/${groupId}/branch_group/`,
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setExpensesGroupNotFound", false);
            commit("refreshExpensesGroup", response.data["group"]);
            commit("refreshExpenses", response.data["group_items"]);
            resolve(response);
          })
          .catch((error) => {
            if (error.response && error.response.status === 404)
              commit("setExpensesGroupNotFound", true);
            else dispatch("handleError", error);
            reject(error);
          });
      });
    },

    createGroup({ dispatch, commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/v1/analyses/group/`, payload, tokenConfig(rootState))
          .then((response) => {
            dispatch("getGroups", response.data.branch);
            commit("setNewGroupDialog", false);
            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Group was created",
            });
            resolve(response);
          })
          .catch((error) => {
            dispatch("handleError", error);
            reject(error);
          });
      });
    },

    createExpensesGroup({ dispatch, commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/v1/expenses/group/`, payload, tokenConfig(rootState))
          .then((response) => {
            dispatch("getExpensesGroups", response.data.branch);
            commit("setNewExpensesGroupDialog", false);
            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Expenses Group was created",
            });
            resolve(response);
          })
          .catch((error) => {
            dispatch("handleError", error);
            reject(error);
          });
      });
    },

    addGroupItems({ dispatch, commit, rootState, state }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            `/api/v1/analyses/group/${state.group.id}/add_items/`,
            { group_items: payload },
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setGroupNotFound", false);
            dispatch("getGroup", state.group.id);
            dispatch("getProducts", state.group.branch);
            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Group was updated",
            });
            resolve(response);
          })
          .catch((error) => {
            dispatch("handleError", error);
            reject(error);
          });
      });
    },

    addExpense({ dispatch, commit, rootState, state }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            `/api/v1/analyses/group/${state.group.id}/add_items/`,
            { group_items: payload },
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setExpensesGroupNotFound", false);
            dispatch("getExpensesGroup", state.expenseGroup.id);
            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Group was updated",
            });
            resolve(response);
          })
          .catch((error) => {
            dispatch("handleError", error);
            reject(error);
          });
      });
    },

    updateGroupItemCostPrice({ dispatch, commit, rootState, state }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            `/api/v1/analyses/group/${state.groupItem.id}/update_cost_price/`,
            { cost_price: payload },
            tokenConfig(rootState)
          )
          .then((response) => {
            dispatch("getGroup", state.group.id);
            dispatch("getProducts", state.group.branch);
            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Group Item was updated",
            });
            resolve(response);
          })
          .catch((error) => {
            dispatch("handleError", error);
            reject(error);
          });
      });
    },

    deleteGroupItem({ dispatch, commit, rootState, state }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            `/api/v1/analyses/group/${state.groupItem.id}/delete_item/`,
            tokenConfig(rootState)
          )
          .then((response) => {
            dispatch("getGroup", state.group.id);
            dispatch("getProducts", state.group.branch);
            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Group Item was deleted",
            });
            resolve(response);
          })
          .catch((error) => {
            dispatch("handleError", error);
            reject(error);
          });
      });
    },

    loadGroupAnalyses({ dispatch, commit, rootState, state }) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            `/api/v1/analyses/group/${state.group.id}/group_analyses/`,
            {
              fromDate: state.groupTimelineDateFrom,
              fromTime: state.groupTimelineTimeFrom,
              toDate: state.groupTimelineDateTo,
              toTime: state.groupTimelineTimeTo,
            },
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Ready Analyses",
            });

            var order;
            var sale;
            var orders;
            var sales;
            var duplicateOrder;
            var duplicateSale;
            var breakdownItemsByName = [];
            var breakdownItemsByPrice = [];

            state.groupItems.map((groupItem) => {
              breakdownItemsByName.push({
                id: groupItem.item_id,
                cost_price: groupItem.cost_price,
                name: groupItem.name,
                orders: 0,
                sales: 0,
                total: 0,
              });
            });

            commit("setAnalysesValues", {
              expectedRevenue: response.data.expected_revenue,
              expectedCost: response.data.expected_cost,
              expectedProfit: response.data.expected_profit,
              actualRevenue: response.data.actual_revenue,
              actualCost: response.data.actual_cost,
              actualProfit: response.data.actual_profit,
              fromTimeline: response.data.from_timeline,
              toTimeline: response.data.to_timeline,
            });

            //Accumulate Breakdown Items By Name
            for (order of response.data.order_items) {
              duplicateOrder = breakdownItemsByName.filter(
                (breakdownItem) => breakdownItem.id === order.item_id
              );
              if (duplicateOrder.length) {
                orders = duplicateOrder[0].orders += Number(order.quantity);

                Vue.set(duplicateOrder[0], "orders", orders);
              }
            }
            for (sale of response.data.sales_items) {
              duplicateSale = breakdownItemsByName.filter(
                (breakdownItem) => breakdownItem.id === sale.item_id
              );
              if (duplicateSale.length) {
                sales = duplicateSale[0].sales += Number(sale.quantity);

                Vue.set(duplicateSale[0], "sales", sales);
              }
            }
            breakdownItemsByName.map((breakdownItem) => {
              Vue.set(
                breakdownItem,
                "total",
                breakdownItem.orders + breakdownItem.sales
              );
            });

            breakdownItemsByName.map((groupItem) => {
              var byPrice = breakdownItemsByPrice.filter(
                (item) => item.cost_price === groupItem.cost_price
              );
              if (byPrice.length === 0)
                breakdownItemsByPrice.push({
                  cost_price: groupItem.cost_price,
                  orders: 0,
                  sales: 0,
                  total: 0,
                  evaluation: 0,
                });
            });

            for (var byPriceItem of breakdownItemsByName) {
              // var index = indexOf(breakdownItemsByPrice[item.cost_price]);
              // var ordersAddUp =
              // Vue.set(breakdownItemsByPrice[index], "orders", orders);
              var ordersAddUp = 0;
              var salesAddUp = 0;
              var index = breakdownItemsByPrice.indexOf(
                breakdownItemsByPrice.find(
                  (o) => o.cost_price === byPriceItem.cost_price
                )
              );
              ordersAddUp =
                breakdownItemsByPrice[index].orders + byPriceItem.orders;
              salesAddUp =
                breakdownItemsByPrice[index].sales + byPriceItem.sales;

              Vue.set(breakdownItemsByPrice[index], "orders", ordersAddUp);
              Vue.set(breakdownItemsByPrice[index], "sales", salesAddUp);
            }

            // //Accumulate Breakdown Items By Price
            // for (order of response.data.order_items) {
            //   duplicateOrder = breakdownItemsByPrice.filter(
            //     (breakdownItem) =>
            //       breakdownItem.selling_price === Number(order.price)
            //   );
            //   if (duplicateOrder.length) {
            //     orders = duplicateOrder[0].orders += Number(order.quantity);

            //     Vue.set(duplicateOrder[0], "orders", orders);
            //   }
            // }
            // for (sale of response.data.sales_items) {
            //   duplicateSale = breakdownItemsByPrice.filter(
            //     (breakdownItem) =>
            //       breakdownItem.selling_price === Number(sale.price)
            //   );
            //   if (duplicateSale.length) {
            //     sales = duplicateSale[0].sales += Number(sale.quantity);

            //     Vue.set(duplicateSale[0], "sales", sales);
            //   }
            // }
            breakdownItemsByPrice.map((breakdownItem) => {
              Vue.set(
                breakdownItem,
                "total",
                breakdownItem.orders + breakdownItem.sales
              );
              Vue.set(
                breakdownItem,
                "evaluation",
                Number(breakdownItem.total) * Number(breakdownItem.cost_price)
              );
            });

            //Filter and remove items with zero total
            var finalBreakdownItemsByName = breakdownItemsByName.filter(
              (breakdownItem) => breakdownItem.total > 0
            );
            var finalBreakdownItemsByPrice = breakdownItemsByPrice.filter(
              (breakdownItem) => breakdownItem.total > 0
            );

            commit("setBreakdownItemsByName", finalBreakdownItemsByName);
            commit(
              "setBreakdownItemsByPrice",
              finalBreakdownItemsByPrice.sort(function(a, b) {
                return Number(a.cost_price) - Number(b.cost_price);
              })
            );

            commit("setBreakdownItemsByOrders", response.data.order_items);
            commit("setBreakdownItemsBySales", response.data.sales_items);

            resolve(response);
          })
          .catch((error) => {
            dispatch("handleError", error);
            reject(error);
          });
      });
    },

    loadGroupAnalysesB({ dispatch, commit, rootState, state }) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            `/api/v1/analyses/group/${state.group.id}/group_analyses_b/`,
            {
              fromDate: state.groupTimelineDateFrom,
              fromTime: state.groupTimelineTimeFrom,
              toDate: state.groupTimelineDateTo,
              toTime: state.groupTimelineTimeTo,
            },
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Ready Analyses",
            });

            var order;
            var sale;
            var orders;
            var sales;
            var duplicateOrder;
            var duplicateSale;
            var breakdownItemsByName = [];
            var breakdownItemsByPrice = [];

            state.groupItems.map((groupItem) => {
              breakdownItemsByName.push({
                id: groupItem.item_id,
                cost_price: groupItem.cost_price,
                name: groupItem.name,
                orders: 0,
                sales: 0,
                total: 0,
              });
            });

            commit("setAnalysesValues", {
              expectedRevenue: response.data.expected_revenue,
              expectedCost: response.data.expected_cost,
              expectedProfit: response.data.expected_profit,
              actualRevenue: response.data.actual_revenue,
              actualCost: response.data.actual_cost,
              actualProfit: response.data.actual_profit,
              fromTimeline: response.data.from_timeline,
              toTimeline: response.data.to_timeline,
            });

            //Accumulate Breakdown Items By Name
            for (order of response.data.order_items) {
              duplicateOrder = breakdownItemsByName.filter(
                (breakdownItem) => breakdownItem.id === order.item_id
              );
              if (duplicateOrder.length) {
                orders = duplicateOrder[0].orders += Number(order.quantity);

                Vue.set(duplicateOrder[0], "orders", orders);
              }
            }
            for (sale of response.data.sales_items) {
              duplicateSale = breakdownItemsByName.filter(
                (breakdownItem) => breakdownItem.id === sale.item_id
              );
              if (duplicateSale.length) {
                sales = duplicateSale[0].sales += Number(sale.quantity);

                Vue.set(duplicateSale[0], "sales", sales);
              }
            }
            breakdownItemsByName.map((breakdownItem) => {
              Vue.set(
                breakdownItem,
                "total",
                breakdownItem.orders + breakdownItem.sales
              );
            });

            breakdownItemsByName.map((groupItem) => {
              var byPrice = breakdownItemsByPrice.filter(
                (item) => item.cost_price === groupItem.cost_price
              );
              if (byPrice.length === 0)
                breakdownItemsByPrice.push({
                  cost_price: groupItem.cost_price,
                  orders: 0,
                  sales: 0,
                  total: 0,
                  evaluation: 0,
                });
            });

            for (var byPriceItem of breakdownItemsByName) {
              var ordersAddUp = 0;
              var salesAddUp = 0;
              var index = breakdownItemsByPrice.indexOf(
                breakdownItemsByPrice.find(
                  (o) => o.cost_price === byPriceItem.cost_price
                )
              );
              ordersAddUp =
                breakdownItemsByPrice[index].orders + byPriceItem.orders;
              salesAddUp =
                breakdownItemsByPrice[index].sales + byPriceItem.sales;

              Vue.set(breakdownItemsByPrice[index], "orders", ordersAddUp);
              Vue.set(breakdownItemsByPrice[index], "sales", salesAddUp);
            }

            breakdownItemsByPrice.map((breakdownItem) => {
              Vue.set(
                breakdownItem,
                "total",
                breakdownItem.orders + breakdownItem.sales
              );
              Vue.set(
                breakdownItem,
                "evaluation",
                Number(breakdownItem.total) * Number(breakdownItem.cost_price)
              );
            });

            //Filter and remove items with zero total
            var finalBreakdownItemsByName = breakdownItemsByName.filter(
              (breakdownItem) => breakdownItem.total > 0
            );
            var finalBreakdownItemsByPrice = breakdownItemsByPrice.filter(
              (breakdownItem) => breakdownItem.total > 0
            );

            commit("setBreakdownItemsByName", finalBreakdownItemsByName);
            commit(
              "setBreakdownItemsByPrice",
              finalBreakdownItemsByPrice.sort(function(a, b) {
                return Number(a.cost_price) - Number(b.cost_price);
              })
            );

            commit("setBreakdownItemsByOrders", response.data.order_items);
            commit("setBreakdownItemsBySales", response.data.sales_items);

            resolve(response);
          })
          .catch((error) => {
            dispatch("handleError", error);
            reject(error);
          });
      });
    },

    loadGroupAnalysesC({ dispatch, commit, rootState, state }) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            `/api/v1/analyses/group/${state.group.id}/group_analyses_c/`,
            {
              fromDate: state.groupTimelineDateFrom,
              fromTime: state.groupTimelineTimeFrom,
              toDate: state.groupTimelineDateTo,
              toTime: state.groupTimelineTimeTo,
            },
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Ready Analyses",
            });

            var order;
            var sale;
            var orders;
            var sales;
            var duplicateOrder;
            var duplicateSale;
            var breakdownItemsByName = [];
            var breakdownItemsByPrice = [];

            state.groupItems.map((groupItem) => {
              breakdownItemsByName.push({
                id: groupItem.item_id,
                cost_price: groupItem.cost_price,
                name: groupItem.name,
                orders: 0,
                sales: 0,
                total: 0,
              });
            });

            commit("setAnalysesValues", {
              expectedRevenue: response.data.expected_revenue,
              expectedCost: response.data.expected_cost,
              expectedProfit: response.data.expected_profit,
              actualRevenue: response.data.actual_revenue,
              actualCost: response.data.actual_cost,
              actualProfit: response.data.actual_profit,
              fromTimeline: response.data.from_timeline,
              toTimeline: response.data.to_timeline,
            });

            //Accumulate Breakdown Items By Name
            for (order of response.data.order_items) {
              duplicateOrder = breakdownItemsByName.filter(
                (breakdownItem) => breakdownItem.id === order.item_id
              );
              if (duplicateOrder.length) {
                orders = duplicateOrder[0].orders += Number(order.quantity);

                Vue.set(duplicateOrder[0], "orders", orders);
              }
            }
            for (sale of response.data.sales_items) {
              duplicateSale = breakdownItemsByName.filter(
                (breakdownItem) => breakdownItem.id === sale.item_id
              );
              if (duplicateSale.length) {
                sales = duplicateSale[0].sales += Number(sale.quantity);

                Vue.set(duplicateSale[0], "sales", sales);
              }
            }
            breakdownItemsByName.map((breakdownItem) => {
              Vue.set(
                breakdownItem,
                "total",
                breakdownItem.orders + breakdownItem.sales
              );
            });

            breakdownItemsByName.map((groupItem) => {
              var byPrice = breakdownItemsByPrice.filter(
                (item) => item.cost_price === groupItem.cost_price
              );
              if (byPrice.length === 0)
                breakdownItemsByPrice.push({
                  cost_price: groupItem.cost_price,
                  orders: 0,
                  sales: 0,
                  total: 0,
                  evaluation: 0,
                });
            });

            for (var byPriceItem of breakdownItemsByName) {
              var ordersAddUp = 0;
              var salesAddUp = 0;
              var index = breakdownItemsByPrice.indexOf(
                breakdownItemsByPrice.find(
                  (o) => o.cost_price === byPriceItem.cost_price
                )
              );
              ordersAddUp =
                breakdownItemsByPrice[index].orders + byPriceItem.orders;
              salesAddUp =
                breakdownItemsByPrice[index].sales + byPriceItem.sales;

              Vue.set(breakdownItemsByPrice[index], "orders", ordersAddUp);
              Vue.set(breakdownItemsByPrice[index], "sales", salesAddUp);
            }

            breakdownItemsByPrice.map((breakdownItem) => {
              Vue.set(
                breakdownItem,
                "total",
                breakdownItem.orders + breakdownItem.sales
              );
              Vue.set(
                breakdownItem,
                "evaluation",
                Number(breakdownItem.total) * Number(breakdownItem.cost_price)
              );
            });

            //Filter and remove items with zero total
            var finalBreakdownItemsByName = breakdownItemsByName.filter(
              (breakdownItem) => breakdownItem.total > 0
            );
            var finalBreakdownItemsByPrice = breakdownItemsByPrice.filter(
              (breakdownItem) => breakdownItem.total > 0
            );

            commit("setBreakdownItemsByName", finalBreakdownItemsByName);
            commit(
              "setBreakdownItemsByPrice",
              finalBreakdownItemsByPrice.sort(function(a, b) {
                return Number(a.cost_price) - Number(b.cost_price);
              })
            );

            commit("setBreakdownItemsByOrders", response.data.order_items);
            commit("setBreakdownItemsBySales", response.data.sales_items);

            resolve(response);
          })
          .catch((error) => {
            dispatch("handleError", error);
            reject(error);
          });
      });
    },

    updateGroup({ dispatch, commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            `/api/v1/analyses/group/${payload.groupId}/update_group/`,
            { [payload.reference]: payload.data },
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setGroupNotFound", false);
            commit("refreshProduct", response.data);
            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Group was updated",
            });
            resolve(response);
          })
          .catch((error) => {
            if (error.response && error.response.status === 404)
              commit("setGroupNotFound", true);
            else dispatch("handleError", error);
            reject(error);
          });
      });
    },

    deleteGroup({ dispatch, commit, rootState }, groupId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            `/api/v1/analyses/group/${groupId}/delete_group/`,
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setGroupNotFound", false);
            commit("refreshGroup", response.data);
            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Group was deleted",
            });
            resolve(response);
          })
          .catch((error) => {
            if (error.response && error.response.status === 404)
              commit("setGroupNotFound", true);
            else dispatch("handleError", error);
            reject(error);
          });
      });
    },

    sendAnalysesReport({ dispatch, commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            `/api/v1/analyses/group/${state.group.id}/send_report/`,
            {
              recipients: payload,
              analysesValues: state.analysesValues,
              byPrice: state.breakdownItemsByPrice,
              byName: state.breakdownItemsByName,
            },
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setGroupNotFound", false);
            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Report was sent",
            });
            resolve(response);
          })
          .catch((error) => {
            if (error.response && error.response.status === 404)
              commit("setGroupNotFound", true);
            else dispatch("handleError", error);
            reject(error);
          });
      });
    },
  },
};
